module.exports = __webpack_public_path__ + "static/media/info-sign.f6874b6d.svg";